/**
 * key para asignar permisos se separa con "|", ej: "billing|charges"
 * @type {[{leftIcon: string, label: string, key: string, permission: string}]}
 */
const options = [
  {
    key: 'sau',
    permission:'sau',
    label: 'sidebar.option1',
    leftIcon: 'customer-service'
  },
  {
    key: 'sau_search',
    permission:'sau_search',
    label: 'sidebar.option2',
    leftIcon: 'search'
  },
  {
    key: 'sau_statistics',
    permission:'sau_statistics',
    label: 'sidebar.option3',
    leftIcon: 'area-chart'
  },
  {
    key: 'control_panel',
    permission:'control_panel',
    label: 'sidebar.option12',
    leftIcon: 'control'
  },
  {
    key: 'processes',
    permission:'processes',
    label: 'sidebar.option4',
    leftIcon: 'code',
  },
  {
    key: 'billing',
    permission:'billing',
    label: 'sidebar.option13',
    leftIcon: 'file-done',
  },
  {
    key: 'billable_concepts',
    permission:'billable_concepts',
    label: 'sidebar.option14',
    leftIcon: 'audit'
  },
  {
    key: 'charges',
    permission:'charges',
    label: 'sidebar.option6',
    leftIcon: 'dollar',
  },
  //{
  //  key: 'charges_statistics',
  //  permission::'charges_statistics',
  //  label: 'sidebar.option7',
  //  leftIcon: 'area-chart'
  //},
  {
    key: 'transits',
    permission:'transitos',
    label: 'sidebar.option17',
    leftIcon: 'car'
  },
  {
    key: 'reports',
    permission:'reports',
    label: 'sidebar.option8',
    leftIcon: 'file-excel'
  },
  {
    key: 'settings',
    permission:'settings',
    label: 'sidebar.option9',
    leftIcon: 'setting'
  },
  {
    key: 'faq',
    permission:'faq',
    label: 'sidebar.option10',
    leftIcon: 'question'
  },
  {
    key: 'logs',
    permission:'logs',
    label: 'sidebar.option11',
    leftIcon: 'unordered-list'
  },
  {
    key: 'toll_operator',
    permission:'asigpeajista',
    label: 'sidebar.option15',
    leftIcon: 'team'
  },
  {
    key: 'emails',
    permission:'email',
    label: 'sidebar.option16',
    leftIcon: 'mail'
  },
];
export default options;
